import { Link } from "react-router-dom";
import { Crown } from "lucide-react";
import { PerkList, PriceBlock, PRO_PERKS } from "@/components/PriceBlock";
import { withNext } from "@/lib/api";

const FREE_PERKS = ["2 worlds", "Every wiki feature: categories, timelines, relationship maps, family trees, rich text, galleries", "The writing desk: 3 works with chapters, goals, streaks, book pages and notes", "Dark and light themes", "Private by default, optional public link"];
const btn = "block text-center rounded-full h-11 leading-[2.75rem] font-semibold transition-colors";

const proCta = (user, status, interval) => {
  if (user && status?.is_pro) return null;
  const to = user ? `/billing?interval=${interval}` : withNext("/register", `/billing?interval=${interval}`);
  return <Link to={to} className={`${btn} bg-amber-500 hover:bg-amber-400 text-onaccent`} data-testid="pricing-get-pro-btn">Get Pro</Link>;
};

export const FreeCard = ({ user, limit }) => (
  <div className="rounded-2xl border border-line bg-panel p-7 space-y-6" data-testid="pricing-free-card">
    <h2 className="font-display text-2xl text-amber-100">Free</h2>
    <p><span className="font-display text-5xl text-amber-50">$0</span><span className="text-slate-400"> / forever</span></p>
    <PerkList perks={[`${limit} worlds`, ...FREE_PERKS.slice(1)]} />
    <Link to={user ? "/worlds" : "/register"} className={`${btn} border border-line text-slate-200 hover:border-amber-500/40`} data-testid="pricing-start-free-btn">
      {user ? "Go to my worlds" : "Start free"}
    </Link>
  </div>
);

export const ProCard = ({ user, status, interval, prices }) => {
  const label = status?.source === "gift" ? "Gift" : status?.interval === "year" ? "Yearly" : "Monthly";
  return (
    <div className="rounded-2xl border border-amber-500/40 bg-panel p-7 space-y-6 shadow-[0_0_40px_rgba(245,158,11,0.12)]" data-testid="pricing-pro-card">
      <div className="flex items-center gap-2"><Crown className="w-5 h-5 text-amber-400" /><h2 className="font-display text-2xl text-amber-100">Pro</h2></div>
      <PriceBlock interval={interval} prices={prices} />
      <PerkList perks={PRO_PERKS} />
      {status?.is_pro ? (
        <div className="space-y-2">
          <p className="text-sm text-amber-200" data-testid="pricing-pro-status">You're on Pro · {label}</p>
          <Link to="/billing" className="text-sm text-slate-400 hover:text-amber-300 underline-offset-4 hover:underline" data-testid="pricing-billing-link">View billing</Link>
        </div>
      ) : proCta(user, status, interval)}
    </div>
  );
};
